import React, { useEffect, useRef, useState } from 'react';
import LocalModal from 'components/base/local-modal';
import busyTag from 'assets/images/busy-tag.png';
import { Button } from '@cokitchen/cokitchen-components';
import { CoKitchenType } from 'models/cokitchen.model';
import { calculateReactivationTime, getCountdownWords } from 'utils/functions';
import { BrandType } from 'models/brand.model';

type Props = {
  open: boolean;
  onClose: () => void;
  data: CoKitchenType | BrandType;
};

const BusyModal = (props: Props) => {
  const mounting = useRef(true);
  const { open, data, onClose } = props;
  const [reactivationTime, setReactivationTime] = useState(
    calculateReactivationTime(data.reactivation_time)
  );

  useEffect(() => {
    if (reactivationTime <= 0 && !mounting.current) onClose();
    return () => {
      mounting.current = false;
    };
  }, [reactivationTime]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const time = calculateReactivationTime(data.reactivation_time);
      setReactivationTime(time);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [data.reactivation_time]);

  return (
    <LocalModal isOpen={open} onRequestClose={onClose}>
      <div className='flex flex-col items-center justify-center text-center gap-8 p-5'>
        <img src={busyTag} />
        <p className='font-medium'>Sorry, we can&apos;t process new orders at this time</p>
        <p className='text-sm text-[#C4C4C4]'>
          {data.reactivation_time
            ? `We will be back in ${getCountdownWords(data.reactivation_time)}`
            : 'We will be back soon'}
        </p>
        <Button variant='block' color='primary' onClick={onClose}>
          Ok
        </Button>
      </div>
    </LocalModal>
  );
};

export default BusyModal;
